module.exports = __webpack_public_path__ + "img/germany-stomach-cancer-male.728cd978.png";